export const svgButtonStyle = { width: 16, height: 16 };
